import * as React from 'react';
//import {BrowserRouter as Router} from 'react-router-dom';
//import LoginPage from '../components/LoginPage'
//import SignupPage from '../components/SignupPage'
//import SignupConfirmPage from '../components/SignupConfirmPage'
//import ForgotPasswordPage from './ForgotPasswordPage'
//import ForgotPasswordConfirm from "./ForgotPasswordConfirmPage";
//import SignupConfirmLinkPage from "../components/SignupConfirmLinkPage";
//import AmplifyTheme from '../style/AmplifyTheme';
//import LoginPage from "./LoginPage";
//import AuthSuccessPage from "./AuthSuccessPage";
//import SignupPage from "./SignupPage";
//import ForgotPasswordPage from "./ForgotPasswordPage";
//import SignupConfirmPage from "./SignupConfirmPage";
import '@aws-amplify/ui-react/styles.css';
import '../style/auth_styles.css';
import {useAuthenticator, useTheme, View, Text, Image} from "@aws-amplify/ui-react";
import { Authenticator } from '@aws-amplify/ui-react';

interface AuthenticatedComponentProps {
    authSettings:AuthSettings;
    children:any;
    signOut:any;
    user:any;
    loginMechanisms:string[];
}

export default function AuthenticatedComponent(props:AuthenticatedComponentProps) {
    const { route } = useAuthenticator(context => [context.route]);
    console.log(route);

    if (route === "authenticated") {
        if (props.authSettings.handleAuthStateChangeCallback) {
            props.authSettings.handleAuthStateChangeCallback(route);
        }
    } else if (route === "signUp") {

    } else if (route === "confirmSignUp") {

    }

    const componentProps = props;
    const components = {

        Header() {
            const {tokens} = useTheme();

            return (
                <View textAlign="center" padding={tokens.space.large}>
                    <Image
                        alt="logo"
                        style={{width:"100px"}}
                        src={componentProps.authSettings.image}
                    />
                </View>
            );
        },

        Footer() {
            const {tokens} = useTheme();

            return (
                <View textAlign="center" padding={tokens.space.large}>
                    <Text color={tokens.colors.neutral[80]}>
                        &copy; {componentProps.authSettings.title}. All Rights Reserved
                    </Text>
                </View>
            );
        },
    };

    return (
        <Authenticator loginMechanisms={props.authSettings.loginMechanisms} signUpAttributes={props.authSettings.signUpAttributes} components={components} hideSignUp={!props.authSettings.signupEnabled}>
            {({ signOut, user }: {signOut:any, user:any}) => (
                props.children
            )}
        </Authenticator>
    );
}


//export default withAuthenticator(AuthenticatedComponent, {loginMechanisms:['email'], signUpAttributes:['name', 'phone_number'], components:components});

/*export async function getStaticProps() {
    return {
        props: {
            isPassedToWithAuthenticator: true,
        },
    };
}*/